export default __webpack_public_path__ + "media/zurb/img/legacy/icons/feeder/bounce-a1a86e8b1606e54ba2af100a94bc0fbf.png";